import React, { Fragment } from 'react'

const HeaderDesignCreation = () => {

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 dashBoard">
                        <h2>Design Creation</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default HeaderDesignCreation
